var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M2.074-.85A2.924,2.924,0,1,1-.85,2.074,2.927,2.927,0,0,1,2.074-.85Zm0,4.557A1.633,1.633,0,1,0,.441,2.074,1.635,1.635,0,0,0,2.074,3.707Z",
    transform: "translate(6.926 6.926)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M9.211,18.15a2.167,2.167,0,0,1-2.165-2.165v-.059a.6.6,0,0,0-.4-.55l-.038-.015a.607.607,0,0,0-.668.12l-.042.042A2.165,2.165,0,1,1,2.838,12.46l.042-.042A.6.6,0,0,0,3,11.75l0-.006a.607.607,0,0,0-.556-.368H2.315a2.165,2.165,0,1,1,0-4.329h.059a.6.6,0,0,0,.55-.4q.007-.019.015-.038a.6.6,0,0,0-.12-.668L2.777,5.9A2.165,2.165,0,1,1,5.84,2.838l.042.042A.607.607,0,0,0,6.55,3,.646.646,0,0,1,6.7,2.955a.607.607,0,0,0,.287-.514V2.315a2.165,2.165,0,1,1,4.329,0v.068a.606.606,0,0,0,.368.553l.006,0a.607.607,0,0,0,.668-.12l.043-.043A2.165,2.165,0,1,1,15.462,5.84l-.042.042a.6.6,0,0,0-.12.668.645.645,0,0,1,.045.148.607.607,0,0,0,.514.287h.127a2.165,2.165,0,1,1,0,4.329h-.068a.606.606,0,0,0-.553.368l0,.006a.6.6,0,0,0,.12.668l.043.043a2.165,2.165,0,1,1-3.063,3.062l-.042-.042a.607.607,0,0,0-.668-.12l-.006,0a.607.607,0,0,0-.368.556v.127A2.167,2.167,0,0,1,9.211,18.15Zm-2.1-3.978A1.888,1.888,0,0,1,8.337,15.9q0,.008,0,.015v.068a.873.873,0,1,0,1.747,0v-.129A1.907,1.907,0,0,1,13.323,14.5l.005.005.046.046a.874.874,0,1,0,1.237-1.236l-.046-.046-.005-.005a1.909,1.909,0,0,1,1.355-3.239h.071a.873.873,0,1,0,0-1.747h-.129a1.9,1.9,0,0,1-1.74-1.151.645.645,0,0,1-.048-.182A1.889,1.889,0,0,1,14.5,4.977l.005-.005.046-.046A.874.874,0,1,0,13.313,3.69l-.046.046-.005.005a1.909,1.909,0,0,1-3.239-1.355V2.315a.873.873,0,1,0-1.747,0v.129a1.9,1.9,0,0,1-1.151,1.74.645.645,0,0,1-.182.048A1.9,1.9,0,0,1,4.977,3.8L4.972,3.8l-.046-.046A.874.874,0,1,0,3.69,4.987l.046.046.005.005a1.89,1.89,0,0,1,.388,2.076A1.888,1.888,0,0,1,2.4,8.337H2.315a.873.873,0,1,0,0,1.747h.129A1.909,1.909,0,0,1,3.8,13.323l-.005.005-.046.046A.874.874,0,1,0,4.987,14.61l.046-.046.005-.005a1.9,1.9,0,0,1,2.076-.388Z",
    transform: "translate(-0.15 -0.15)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f4365a94bf709606da3c19b160409fb6.svg";
export { ForwardRef as ReactComponent };